import React from "react";
import { Link } from "react-router-dom";
import "./Services.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Services = () => {
  const services = [
    {
      title: "Divorce Law",
      icon: "fa-scale-balanced",
      description: "From petition to final decree, we guide you through every step with clarity and confidence.",
      details: [
        "No-fault divorce proceedings",
        "Separation agreements",
        "Nullity and annulment",
        "International divorce cases",
        "Jurisdiction disputes",
        "Complete legal representation throughout the process"
      ]
    },
    {
      title: "Financial Settlements",
      icon: "fa-coins",
      description: "Ensuring fair division of assets, pensions, and financial support.",
      details: [
        "Asset division and valuation",
        "Pension sharing and offsetting",
        "Spousal maintenance agreements",
        "Property settlement negotiations",
        "High net worth financial disputes",
        "Third-party interest claims",
        "Trust and ownership disputes"
      ]
    },
    {
      title: "Children & Parenting Arrangements",
      icon: "fa-users",
      description: "Focused on the best interests of your children — including residence, contact, and safety concerns.",
      details: [
        "Child arrangement orders",
        "Residence and contact arrangements",
        "Parental responsibility matters",
        "Relocation cases",
        "Child protection and safeguarding",
        "Domestic abuse injunctions",
        "International child disputes"
      ]
    },
    {
      title: "Pre-Nuptial & Post-Nuptial Agreements",
      icon: "fa-file-contract",
      description: "Protect your future with legally sound agreements tailored to your needs.",
      details: [
        "Pre-nuptial agreement drafting",
        "Post-nuptial agreements",
        "Cohabitation agreements",
        "Asset protection planning",
        "International agreement recognition",
        "Agreement enforcement and disputes"
      ]
    },
    {
      title: "Mediation & Alternative Dispute Resolution",
      icon: "fa-comments",
      description: "Helping you find sensible solutions outside of court.",
      details: [
        "Family mediation services",
        "Collaborative law processes",
        "Arbitration and private FDR",
        "Negotiation support",
        "Settlement agreement drafting",
        "Court alternative strategies"
      ]
    },
    {
      title: "Domestic Abuse & Injunctions",
      icon: "fa-shield-halved",
      description: "Protecting you and your family with urgent legal protection when needed.",
      details: [
        "Non-molestation orders",
        "Occupation orders",
        "Emergency protection applications",
        "Restraining orders",
        "Support and safety planning",
        "Criminal and civil remedies"
      ]
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Our Legal Services</h1>
          <p className="page-hero-subtitle">
            Comprehensive family law expertise tailored to your unique situation
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="page-content">
        <div className="page-wrapper">
          {/* Intro */}
          <div className="services-intro">
            <h2>Expert Legal Support Across All Areas of Family Law</h2>
            <p>
              With over 15 years of experience, we provide specialist support in all areas of family and matrimonial law. 
              Whether you're navigating divorce, protecting your children, or securing your financial future, 
              we're here to guide you with expertise, empathy, and professionalism.
            </p>
          </div>

          {/* Services Grid */}
          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-header">
                  <div className="service-icon"><i className={`fa-solid ${service.icon}`}></i></div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <div className="service-details">
                  <h4>What We Cover:</h4>
                  <ul>
                    {service.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Process Section */}
          <div className="services-process">
            <h2>How We Approach Your Case</h2>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <h4>Initial Consultation</h4>
                <p>We listen carefully to understand your situation, goals, and concerns.</p>
              </div>
              <div className="process-step">
                <div className="step-number">2</div>
                <h4>Strategic Planning</h4>
                <p>We develop a tailored approach based on your unique circumstances.</p>
              </div>
              <div className="process-step">
                <div className="step-number">3</div>
                <h4>Clear Communication</h4>
                <p>You receive regular updates and honest guidance at every stage.</p>
              </div>
              <div className="process-step">
                <div className="step-number">4</div>
                <h4>Focused Resolution</h4>
                <p>We work towards fair, practical outcomes with minimum stress.</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="page-cta">
            <h2>Ready to Discuss Your Case?</h2>
            <p>Book a free consultation to explore how we can help</p>
            <Link to="/contact" className="cta-button">
              Book a Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
